package com.raouf.mehrguard.web.i18n

internal val VietnameseStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Trình Phát Hiện QRishing Kotlin Multiplatform",
    WebStringKey.MenuMain to "Menu Chính",
    WebStringKey.MenuSecurity to "Bảo Mật",
    WebStringKey.MenuSystem to "Hệ Thống",
    WebStringKey.NavDashboard to "Bảng Điều Khiển",
    WebStringKey.NavScanMonitor to "Giám Sát Quét",
    WebStringKey.NavScanHistory to "Lịch Sử Quét",
    WebStringKey.NavTrustCentre to "Trung Tâm Tin Cậy",
    WebStringKey.NavReports to "Báo Cáo",
    WebStringKey.NavTraining to "Đào Tạo",
    WebStringKey.NavSettings to "Cài Đặt",
    WebStringKey.QuickActions to "Hành Động Nhanh",

    // Hero Section
    WebStringKey.HeroTagline to "An Toàn. Ngoại Tuyến.",
    WebStringKey.HeroTagline2 to "Phòng Thủ Có Thể Giải Thích.",
    WebStringKey.HeroDescription to "Mehr Guard phân tích các mối đe dọa tiềm ẩn trực tiếp trên phần cứng của bạn. Trải nghiệm bảo vệ với độ trễ bằng không.",

    // Dashboard
    WebStringKey.StartScan to "Bắt Đầu Quét Mới",
    WebStringKey.ImportImage to "Nhập Hình Ảnh",
    WebStringKey.ScanQrCode to "Quét Mã QR",
    WebStringKey.SystemHealth to "Tình Trạng Hệ Thống",
    WebStringKey.ThreatDatabase to "Cơ Sở Dữ Liệu Mối Đe Dọa",
    WebStringKey.Current to "Hiện Tại",
    WebStringKey.Active to "Hoạt Động",
    WebStringKey.Threats to "Mối Đe Dọa",
    WebStringKey.SafeScans to "Quét An Toàn",
    WebStringKey.EngineActive to "Động Cơ Hoạt Động",
    WebStringKey.EnterpriseProtection to "Bảo Vệ Doanh Nghiệp Hoạt Động",
    WebStringKey.SystemOptimal to "Hệ Thống Tối Ưu",
    WebStringKey.EngineStatus to "Động cơ v2.4 • Cập nhật 2h trước",
    WebStringKey.ThreatsBlocked to "Mối Đe Dọa Đã Chặn",
    WebStringKey.AllSystemsOperational to "Tất cả hệ thống hoạt động",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Tổng Quan",
    WebStringKey.SectionSecurity to "Bảo Mật",
    WebStringKey.SectionTraining to "Đào Tạo",
    WebStringKey.SectionReports to "Báo Cáo",
    WebStringKey.OfflineReady to "Sẵn Sàng Ngoại Tuyến",
    WebStringKey.OfflineDescription to "Cơ sở dữ liệu cục bộ v2.4.1 hoạt động. Không có dữ liệu rời khỏi thiết bị này.",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "Trung Tâm Tin Cậy",
    WebStringKey.OfflineGuarantee to "Đảm Bảo Ngoại Tuyến Nghiêm Ngặt",
    WebStringKey.OfflineGuaranteeDesc to "Phân tích Mehr Guard chạy hoàn toàn trên Neural Engine của thiết bị. Dữ liệu URL không bao giờ rời khỏi điện thoại của bạn.",
    WebStringKey.ThreatSensitivity to "Độ Nhạy Mối Đe Dọa",
    WebStringKey.ResetConfirm to "Điều này sẽ đặt lại tất cả cài đặt Trung Tâm Tin Cậy về mặc định.",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Giám Sát Mối Đe Dọa",
    WebStringKey.ThreatMonitorDesc to "Xem các mối đe dọa trực tiếp và chạy kiểm tra bảo mật",
    WebStringKey.TrustCentreDesc to "Cài đặt quyền riêng tư và độ nhạy mối đe dọa",
    WebStringKey.ExportReport to "Xuất Báo Cáo",
    WebStringKey.ExportReportDesc to "Tạo báo cáo bảo mật PDF hoặc JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Phân Tích",
    WebStringKey.HeuristicEngine to "Động Cơ Heuristic",
    WebStringKey.HighPerformanceEngine to "Động Cơ Hiệu Suất Cao",
    WebStringKey.RecentScans to "Quét Gần Đây",
    WebStringKey.ViewFullHistory to "Xem Lịch Sử Đầy Đủ",
    WebStringKey.Status to "Trạng Thái",
    WebStringKey.Source to "Nguồn",
    WebStringKey.Details to "Chi Tiết",
    WebStringKey.Time to "Thời Gian",
    WebStringKey.Version to "Phiên Bản",
    WebStringKey.LastUpdate to "Cập Nhật Cuối",
    WebStringKey.Signatures to "Chữ Ký",
    WebStringKey.CheckForUpdates to "Kiểm Tra Cập Nhật",
    WebStringKey.FeatureOfflineTitle to "Kiến Trúc Ưu Tiên Ngoại Tuyến",
    WebStringKey.FeatureOfflineDesc to "Phân tích hoàn chỉnh được thực hiện cục bộ. Nguồn cấp camera và dữ liệu quét của bạn không bao giờ chạm đến máy chủ bên ngoài, đảm bảo quyền riêng tư tuyệt đối.",
    WebStringKey.FeatureExplainableTitle to "Bảo Mật Có Thể Giải Thích",
    WebStringKey.FeatureExplainableDesc to "Đừng chỉ nhận \"Chặn\". Chúng tôi cung cấp phân tích heuristic chi tiết về các tham số URL, chuyển hướng và payload JavaScript.",
    WebStringKey.FeaturePerformanceDesc to "Được tối ưu hóa cho môi trường desktop. Quét được xử lý trong dưới 5ms sử dụng các tệp nhị phân Kotlin Multiplatform gốc.",
    WebStringKey.TrainingCentre to "Trung Tâm Đào Tạo",
    WebStringKey.LearnHomograph to "Tìm hiểu cách nhận dạng các cuộc tấn công homograph QR nâng cao.",
    WebStringKey.BeatTheBotAction to "Đánh Bại Bot →",
    WebStringKey.NoScansYet to "Chưa có quét. Bắt đầu quét mới để xem kết quả ở đây.",
    WebStringKey.VerdictSafe to "AN TOÀN",
    WebStringKey.VerdictPhish to "LỪA ĐẢO",
    WebStringKey.VerdictWarn to "CẢNH BÁO",
    WebStringKey.ScoreLabel to "Điểm:",

    // Scanner
    WebStringKey.ActiveScanner to "Máy Quét Hoạt Động",
    WebStringKey.OfflineMode to "Chế Độ Ngoại Tuyến",
    WebStringKey.LiveFeedDisconnected to "NGUỒN CẤP TRỰC TIẾP ĐÃ NGẮT KẾT NỐI",
    WebStringKey.CameraAccessRequired to "Yêu Cầu Truy Cập Camera",
    WebStringKey.CameraAccessDescription to "Kéo và thả hình ảnh mã QR vào đây hoặc bật quyền truy cập camera để bắt đầu quét.",
    WebStringKey.EnableCamera to "Bật Camera",
    WebStringKey.Scanning to "Đang Quét...",
    WebStringKey.ScanHint to "Giữ ổn định. Phân tích ngoại tuyến trong <5ms.",
    WebStringKey.Torch to "Đèn Pin",
    WebStringKey.Gallery to "Thư Viện",
    WebStringKey.PasteUrl to "Dán URL",
    WebStringKey.PasteUrlTitle to "Dán URL Để Phân Tích",
    WebStringKey.AnalyzeUrl to "Phân Tích URL",
    WebStringKey.SystemStatus to "Trạng Thái Hệ Thống",
    WebStringKey.PhishingEngine to "Động Cơ Lừa Đảo",
    WebStringKey.Ready to "SẴN SÀNG",
    WebStringKey.LocalDb to "DB Cục Bộ",
    WebStringKey.Latency to "Độ Trễ",
    WebStringKey.ViewAll to "Xem Tất Cả",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Trang Chủ",
    WebStringKey.BreadcrumbScans to "Quét",
    WebStringKey.OfflineProtection to "Bảo Vệ Ngoại Tuyến",
    WebStringKey.VerdictHighRisk to "PHÁT HIỆN RỦI RO CAO",
    WebStringKey.VerdictDangerous to "Nguy Hiểm",
    WebStringKey.VerdictDangerousDesc to "Mã QR được quét chứa các chỉ báo độc hại liên quan đến lừa đảo và thu thập thông tin xác thực. Không tiếp tục đến URL mục tiêu.",
    WebStringKey.ThreatConfidence to "Độ Tin Cậy Mối Đe Dọa",
    WebStringKey.FlagPhishing to "Nỗ Lực Lừa Đảo",
    WebStringKey.FlagObfuscated to "Script Bị Che Giấu",
    WebStringKey.FlagHomograph to "Tấn Công Homograph",
    WebStringKey.ClearHistory to "Xóa Tất Cả",
    WebStringKey.SectionAttackBreakdown to "Phân Tích Tấn Công",
    WebStringKey.AttackHomographTitle to "Tấn Công Homograph / IDN",
    WebStringKey.AttackHomographDesc to "Phát hiện ký tự Cyrillic bắt chước bảng chữ cái Latin.",
    WebStringKey.AttackVisualLabel to "Giao Diện Trực Quan",
    WebStringKey.AttackPunycodeLabel to "Punycode Thực Tế",
    WebStringKey.AttackHomographExplain to "Tên miền sử dụng 'а' Cyrillic (U+0430) thay vì 'a' Latin (U+0061). Kỹ thuật này thường được sử dụng để lừa người dùng tin rằng họ đang truy cập một dịch vụ hợp pháp.",
    WebStringKey.AttackRedirectTitle to "Chuỗi Chuyển Hướng Đáng Nghi",
    WebStringKey.AttackRedirectDesc to "Phát hiện 3 bước nhảy liên quan đến các dịch vụ rút gọn URL đã biết.",
    WebStringKey.RedirectStart to "Quét Mã QR",
    WebStringKey.RedirectHop to "Bước Nhảy Trung Gian",
    WebStringKey.RedirectFinal to "Đích Cuối Cùng",
    WebStringKey.AttackJsTitle to "JavaScript Bị Che Giấu",
    WebStringKey.AttackJsDesc to "Phát hiện chuỗi entropy cao trong tham số URL.",
    WebStringKey.SectionActions to "Hành Động Được Khuyến Nghị",
    WebStringKey.ActionBlock to "Chặn & Báo Cáo",
    WebStringKey.ActionBlockDesc to "Ngăn chặn truy cập và thông báo quản trị viên",
    WebStringKey.ActionQuarantine to "Cách Ly Trong Sandbox",
    WebStringKey.ActionQuarantineDesc to "Mở an toàn để phân tích",
    WebStringKey.Expected to "Dự Kiến: ",
    WebStringKey.Detected to "Phát Hiện: ",
    WebStringKey.ExplainableSecurity to "Bảo Mật Có Thể Giải Thích",
    WebStringKey.UrlBreakdown to "PHÂN TÍCH URL",
    WebStringKey.FullUrl to "URL ĐẦY ĐỦ",
    WebStringKey.OpenInBrowser to "Mở Trong Trình Duyệt (Rủi Ro)",
    WebStringKey.OpenWarning to "Mở URL này trong trình duyệt có thể khiến bạn gặp rủi ro bảo mật.",
    WebStringKey.RestrictedMode to "Chế Độ Hạn Chế",
    WebStringKey.RestrictedDesc to "URL này đã được đánh dấu là có khả năng nguy hiểm. Xem phân tích bên dưới trước khi tiếp tục.",
    WebStringKey.DangerousWarning to "URL này đã được đánh dấu là có khả năng nguy hiểm. Mở nó có thể khiến bạn gặp lừa đảo, phần mềm độc hại hoặc các mối đe dọa bảo mật khác. Bạn có chắc chắn muốn tiếp tục?",
    WebStringKey.CopyUrl to "Sao Chép URL",
    WebStringKey.Share to "Chia Sẻ",
    WebStringKey.Dismiss to "Đóng",
    WebStringKey.ReasonDomainAge to "Tuổi tên miền dưới 24 giờ.",
    WebStringKey.ReasonSignatures to "Khớp 3 chữ ký trong DB lừa đảo cục bộ.",
    WebStringKey.ReasonAsn to "IP mục tiêu nằm trong ASN có rủi ro cao.",
    WebStringKey.SectionMeta to "Siêu Dữ Liệu Quét",
    WebStringKey.MetaTime to "Thời Gian Quét",
    WebStringKey.MetaSource to "Nguồn",
    WebStringKey.MetaEngine to "Động Cơ",
    WebStringKey.MetaOfflineGuaranteeLabel to "Đảm Bảo Ngoại Tuyến:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Hình ảnh này đã được phân tích cục bộ trên thiết bị của bạn. Không có dữ liệu nào được gửi đến đám mây cho phán quyết này.",
    
    WebStringKey.ScanComplete to "Quét Hoàn Tất",
    WebStringKey.Loading to "Đang Tải...",
    WebStringKey.AnalyzedOffline to "Phân tích ngoại tuyến trong <5ms",
    WebStringKey.NoDataLeaves to "Dữ liệu không rời khỏi thiết bị",
    WebStringKey.ActiveProtection to "Bảo Vệ Hoạt Động",
    WebStringKey.ConfidenceScore to "Điểm Tin Cậy",
    WebStringKey.Analyzing to "ĐANG PHÂN TÍCH...",
    WebStringKey.ProcessingResults to "Đang xử lý kết quả quét...",
    WebStringKey.RiskAssessment to "Đánh Giá Rủi Ro",
    WebStringKey.AnalysisTime to "Thời Gian Phân Tích",
    WebStringKey.Heuristics to "Heuristic",
    WebStringKey.TopAnalysisFactors to "Các Yếu Tố Phân Tích Chính",
    WebStringKey.Pass to "ĐẠT",
    WebStringKey.Info to "THÔNG TIN",
    WebStringKey.Clean to "SẠCH",
    WebStringKey.ValidSslCertificate to "Chứng Chỉ SSL Hợp Lệ",
    WebStringKey.SslCertificateDesc to "Chứng chỉ do DigiCert Inc cấp",
    WebStringKey.EstablishedDomain to "Tên Miền Đã Thiết Lập",
    WebStringKey.EstablishedDomainDesc to "Tên miền đăng ký hơn 5 năm trước",
    WebStringKey.BlacklistStatus to "Trạng Thái Danh Sách Đen",
    WebStringKey.BlacklistStatusDesc to "Không tìm thấy trong 52 DB mối đe dọa cục bộ",
    WebStringKey.BackToDashboard to "Quay Lại Bảng Điều Khiển",
    WebStringKey.ShareReport to "Chia Sẻ Báo Cáo",
    WebStringKey.CopyLink to "Sao Chép Liên Kết",
    WebStringKey.LinkCopied to "Đã sao chép liên kết vào clipboard!",
    WebStringKey.BeatTheBot to "Đánh Bại Bot",
    WebStringKey.BeatTheBotDesc to "Thách thức AI ngoại tuyến của chúng tôi",
    WebStringKey.SessionId to "ID Phiên",
    WebStringKey.EndSession to "Kết Thúc Phiên",
    WebStringKey.Round to "Vòng",
    WebStringKey.BrowserPreview to "Xem Trước Trình Duyệt",
    WebStringKey.MakeDecision to "Đưa ra quyết định của bạn",
    WebStringKey.Phishing to "Lừa Đảo",
    WebStringKey.Legitimate to "Hợp Pháp",
    WebStringKey.LiveHint to "Gợi Ý Trực Tiếp",
    WebStringKey.LiveScoreboard to "Bảng Điểm Trực Tiếp",
    WebStringKey.VsMode to "CHẾ ĐỘ VS",
    WebStringKey.You to "Bạn",
    WebStringKey.Points to "điểm",
    WebStringKey.Streak to "Chuỗi",
    WebStringKey.Accuracy to "Độ Chính Xác",
    WebStringKey.MehrGuardBot to "Mehr Guard Bot",
    WebStringKey.Confidence to "Độ Tin Cậy",
    WebStringKey.RoundAnalysis to "Phân Tích Vòng",
    WebStringKey.Analysis to "Phân Tích",
    WebStringKey.CorrectDecision to "Quyết Định Đúng!",
    WebStringKey.IdentifiedSafe to "Bạn đã xác định đúng URL an toàn",
    WebStringKey.AiNeuralAnalysis to "Phân Tích AI Neural",
    WebStringKey.WhyBotFlagged to "Tại sao bot đánh dấu",
    WebStringKey.EducationalNote to "Ghi Chú Giáo Dục",
    WebStringKey.Correct to "Chính Xác!",
    WebStringKey.SpottedPhishing to "Bạn đã phát hiện đúng URL lừa đảo",
    WebStringKey.Response to "Phản Hồi",
    WebStringKey.NextRound to "Vòng Tiếp Theo",
    WebStringKey.GameOver to "Kết Thúc Trò Chơi!",
    WebStringKey.FinalResults to "Kết Quả Cuối Cùng",
    WebStringKey.YourScore to "Điểm Của Bạn",
    WebStringKey.BotScore to "Điểm Bot",
    WebStringKey.BestStreak to "Chuỗi Tốt Nhất",
    WebStringKey.PlayAgain to "Chơi Lại",
    WebStringKey.ReturnToDashboard to "Quay Lại Bảng Điều Khiển",
    WebStringKey.ExportSecurityReport to "Xuất Báo Cáo Bảo Mật",
    WebStringKey.GenerateReport to "Tạo báo cáo bảo mật đầy đủ",
    WebStringKey.ReportFormat to "Định Dạng Báo Cáo",
    WebStringKey.HumanReadable to "Báo Cáo Có Thể Đọc",
    WebStringKey.HumanReadableDesc to "PDF với phân tích trực quan",
    WebStringKey.MachineReadable to "Dữ Liệu Máy Đọc Được",
    WebStringKey.MachineReadableDesc to "Định dạng JSON cho tích hợp SIEM",
    WebStringKey.DateRange to "Phạm Vi Ngày",
    WebStringKey.Last7Days to "7 Ngày Qua",
    WebStringKey.Last30Days to "30 Ngày Qua",
    WebStringKey.Last90Days to "90 Ngày Qua",
    WebStringKey.AllTime to "Tất Cả",
    WebStringKey.CustomRange to "Phạm Vi Tùy Chỉnh",
    WebStringKey.ReportSections to "Phần Báo Cáo",
    WebStringKey.ExecutiveSummary to "Tóm Tắt",
    WebStringKey.ThreatBreakdown to "Phân Tích Mối Đe Dọa",
    WebStringKey.ScanTimeline to "Dòng Thời Gian Quét",
    WebStringKey.SafeUrlList to "Danh Sách URL An Toàn",
    WebStringKey.GenerateExport to "Xuất Báo Cáo",
    WebStringKey.Success to "Thành Công!",
    WebStringKey.Error to "Lỗi",
    WebStringKey.Warning to "Cảnh Báo",
    WebStringKey.CopiedToClipboard to "Đã sao chép vào clipboard",
    WebStringKey.Cancel to "Hủy",
    WebStringKey.Confirm to "Xác Nhận",
    WebStringKey.Save to "Lưu",
    WebStringKey.Delete to "Xóa",
    WebStringKey.Edit to "Chỉnh Sửa",
    WebStringKey.Close to "Đóng",
    WebStringKey.Back to "Quay Lại",
    WebStringKey.Next to "Tiếp Theo",
    WebStringKey.Previous to "Trước",
    WebStringKey.Submit to "Gửi",
    WebStringKey.Reset to "Đặt Lại",
    WebStringKey.Clear to "Xóa",
    WebStringKey.Search to "Tìm Kiếm",
    WebStringKey.Filter to "Lọc",
    WebStringKey.Sort to "Sắp Xếp",
    WebStringKey.ToggleMenu to "Chuyển Đổi Menu",
    WebStringKey.ToggleTheme to "Chuyển Đổi Giao Diện",
    WebStringKey.Notifications to "Thông Báo",
    WebStringKey.Help to "Trợ Giúp",
    WebStringKey.Profile to "Hồ Sơ",
    WebStringKey.ToggleLightDarkMode to "Chế Độ Sáng/Tối",
    WebStringKey.UrlInputPlaceholder to "Dán URL để phân tích",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    WebStringKey.Scan to "Quét",
    WebStringKey.Result to "Kết Quả",
    WebStringKey.ReportGeneration to "Tạo Báo Cáo",
    WebStringKey.ReportGenerationDesc to "Cấu hình định dạng và tải xuống",
    WebStringKey.OfflineSecurity to "Bảo Mật Ngoại Tuyến",
    WebStringKey.OfflineSecurityDesc to "Dữ liệu không rời khỏi thiết bị này",
    WebStringKey.ChooseFormat to "Chọn Định Dạng",
    WebStringKey.PdfFormatDesc to "Định dạng PDF. Tốt nhất để chia sẻ",
    WebStringKey.JsonFormatDesc to "Định dạng JSON. Tốt nhất cho SIEM",
    WebStringKey.Copy to "Sao Chép",
    WebStringKey.LivePreview to "Xem Trước Trực Tiếp",
    WebStringKey.ReadOnly to "Chỉ Đọc",
    WebStringKey.ThreatAnalysisReport to "Báo Cáo Phân Tích Mối Đe Dọa",
    WebStringKey.Verdict to "Phán Quyết",
    WebStringKey.RiskScore to "Điểm Rủi Ro",
    WebStringKey.TargetUrl to "URL Mục Tiêu",
    WebStringKey.AnalysisSummaryLabel to "Tóm Tắt Phân Tích",
    WebStringKey.TechnicalIndicators to "Chỉ Báo Kỹ Thuật",
    WebStringKey.ExportInfoNote to "Bao gồm tất cả vector mối đe dọa",
    WebStringKey.AllowList to "Danh Sách Cho Phép",
    WebStringKey.BlockList to "Danh Sách Chặn",
    WebStringKey.AddDomain to "Thêm Tên Miền",
    WebStringKey.RemoveDomain to "Xóa Tên Miền",
    WebStringKey.TrustedDomains to "Tên Miền Tin Cậy",
    WebStringKey.BlockedDomains to "Tên Miền Đã Chặn",
    WebStringKey.DomainPlaceholder to "Nhập tên miền",
    WebStringKey.Safe to "An Toàn",
    WebStringKey.TimeAgo to "trước",
    WebStringKey.MinutesAgo to "phút trước",
    WebStringKey.HoursAgo to "giờ trước",
    WebStringKey.Critical to "NGHIÊM TRỌNG",
    WebStringKey.Warn to "CẢNH BÁO",
    WebStringKey.PhishingDetectionSensitivity to "Độ Nhạy Phát Hiện Lừa Đảo",
    WebStringKey.SensitivityDescription to "Điều chỉnh ngưỡng heuristic",
    WebStringKey.SensitivityLow to "Thấp",
    WebStringKey.SensitivityBalanced to "Cân Bằng",
    WebStringKey.SensitivityParanoia to "Hoang Tưởng",
    WebStringKey.BalancedModeRecommended to "Chế Độ Cân Bằng (Khuyến Nghị)",
    WebStringKey.BalancedModeDesc to "Quét các mẫu độc hại",
    WebStringKey.LowSensitivityMode to "Chế độ Độ nhạy Thấp",
    WebStringKey.LowSensitivityModeDesc to "Chỉ chặn các URL độc hại đã biết từ cơ sở dữ liệu mối đe dọa. Dương tính giả tối thiểu, nhưng có thể bỏ lỡ các cuộc tấn công mới.",
    WebStringKey.ParanoiaMode to "Chế độ Paranoia",
    WebStringKey.ParanoiaModeDesc to "Bảo vệ tối đa. Chặn mọi mẫu đáng ngờ bao gồm tên miền mới đăng ký, TLD không phổ biến và bất kỳ URL nào có thủ thuật mã hóa tiềm năng.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard sử dụng các công cụ phân tích heuristic cục bộ. Không có dữ liệu hình ảnh, chuỗi URL hoặc siêu dữ liệu nào rời khỏi thiết bị này trong quá trình quét. Quyền riêng tư của bạn được đảm bảo về mặt toán học.",
    WebStringKey.SignalBrandImpersonation to "Phát hiện giả mạo thương hiệu tiềm năng",
    WebStringKey.SignalCredentialParams to "Các tham số liên quan đến thông tin xác thực trong URL",
    WebStringKey.SignalEncodedPayload to "Phát hiện dữ liệu được mã hóa trong tham số truy vấn",
    WebStringKey.SignalExcessiveSubdomains to "Độ sâu subdomain quá mức ({count} cấp)",
    WebStringKey.SignalHighEntropyHost to "Tính ngẫu nhiên cao trong tên miền",
    WebStringKey.SignalHomographAttack to "Tên miền chứa ký tự homograph/dễ nhầm lẫn",
    WebStringKey.SignalHttpNotHttps to "Sử dụng giao thức HTTP không an toàn",
    WebStringKey.SignalIpAddressHost to "Host là địa chỉ IP thay vì tên miền",
    WebStringKey.SignalLongUrl to "URL dài bất thường ({length} ký tự)",
    WebStringKey.SignalLongUrlMarketing to "URL dài bất thường ({length} ký tự) - chứa tham số marketing",
    WebStringKey.SignalNewlyRegisteredDomain to "Phát hiện tên miền mới đăng ký",
    WebStringKey.SignalNonStandardPort to "Cổng không chuẩn: {port}",
    WebStringKey.SignalNumericSubdomain to "Phát hiện subdomain chỉ có số",
    WebStringKey.SignalSuspiciousPathKeywords to "Từ khóa đáng ngờ trong đường dẫn ({count} được tìm thấy)",
    WebStringKey.SignalSuspiciousTld to "TLD đáng ngờ: {tld}",
    WebStringKey.SignalUrlShortener to "Sử dụng dịch vụ rút gọn URL",
    WebStringKey.SecureEnvironment to "Môi Trường An Toàn",
    WebStringKey.LearnLocalArchitecture to "Tìm hiểu kiến trúc cục bộ",
    WebStringKey.NoCustomDomainsBlocked to "Không có tên miền tùy chỉnh bị chặn",
    WebStringKey.AddManually to "Thêm thủ công",
    WebStringKey.AddedDaysAgo to "Đã thêm 2 ngày trước",
    WebStringKey.AddedWeekAgo to "Đã thêm 1 tuần trước",
    WebStringKey.PrivacyControls to "Điều Khiển Quyền Riêng Tư",
    WebStringKey.StrictOfflineMode to "Chế Độ Ngoại Tuyến Nghiêm Ngặt",
    WebStringKey.DisableExternalPreviews to "Tắt xem trước bên ngoài",
    WebStringKey.AnonymousTelemetry to "Telemetry Ẩn Danh",
    WebStringKey.ShareDetectionStats to "Chia sẻ thống kê phát hiện",
    WebStringKey.AutoCopySafeLinks to "Tự động sao chép liên kết an toàn",
    WebStringKey.CopyTrustedUrls to "Sao chép URL tin cậy",
    WebStringKey.AboutMehrGuard to "Về Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Giấy Phép Nguồn Mở",
    WebStringKey.PrivacyPolicy to "Chính Sách Bảo Mật",
    WebStringKey.Acknowledgements to "Lời Cảm Ơn",
    WebStringKey.ResetAllSettings to "Đặt Lại Tất Cả Cài Đặt",
    WebStringKey.AddToAllowlist to "Thêm Vào Danh Sách Cho Phép",
    WebStringKey.AddToBlocklist to "Thêm Vào Danh Sách Chặn",
    WebStringKey.AnalysedOfflineTitle to "Phân Tích Ngoại Tuyến",
    WebStringKey.YourDataStaysOnDevice to "Dữ liệu của bạn ở lại thiết bị",
    WebStringKey.OnboardingHeroDesc to "Phân tích an toàn trên thiết bị",
    WebStringKey.OnDeviceAnalysis to "Phân Tích Trên Thiết Bị",
    WebStringKey.OnDeviceAnalysisDesc to "Tất cả phát hiện mối đe dọa chạy cục bộ",
    WebStringKey.NoCloudLogs to "Không Có Nhật Ký Đám Mây",
    WebStringKey.NoCloudLogsDesc to "Tắt telemetry đi ra",
    WebStringKey.OnDeviceDB to "DB Trên Thiết Bị",
    WebStringKey.OnDeviceDBDesc to "DB chữ ký mối đe dọa đầy đủ",
    WebStringKey.DataLifecycleVerification to "Xác Minh Vòng Đời Dữ Liệu",
    WebStringKey.SecurityAuditPass to "Kiểm Tra Bảo Mật: ĐẠT",
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc.",
    WebStringKey.Support to "Hỗ Trợ",
    WebStringKey.Terms to "Điều Khoản",
    WebStringKey.SystemsOperational to "Hệ Thống Hoạt Động",
    WebStringKey.SystemSecure to "Hệ Thống An Toàn",
    WebStringKey.VersionStatus to "v2.4.1 • Hệ Thống An Toàn",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2025.12.29",
    WebStringKey.VerifiedBy to "Được xác minh bởi Mehr Guard Enterprise",
    WebStringKey.SampleUserName to "Nguyễn Văn An",
    WebStringKey.SampleUserRole to "Chuyên Viên Bảo Mật",
    WebStringKey.DetailLabel to "Nhãn Chi Tiết",
    WebStringKey.DetailValue to "Giá Trị Chi Tiết",
    WebStringKey.Suspicious to "Đáng Nghi",
    WebStringKey.IncorrectDecision to "Quyết Định Sai",
    WebStringKey.WrongAnswer to "Ồ! Sai rồi",
    WebStringKey.ResponseTime to "Thời Gian Phản Hồi",
    WebStringKey.IncomingMessage to "Tin Nhắn Đến",
    WebStringKey.CertificateIssuer to "Nhà cấp chứng chỉ khớp",
    WebStringKey.DomainAgeTrust to "Tuổi tên miền > 5 năm",
    WebStringKey.WhitelistedRank to "Alexa top 1k",
    WebStringKey.GameEducationalNote to "Ghi Chú Giáo Dục",
    WebStringKey.GameHintTitle to "Gợi Ý Trò Chơi",
    WebStringKey.AddToAllowlistTitle to "Thêm Vào Danh Sách Cho Phép",
    WebStringKey.AddToBlocklistTitle to "Thêm Vào Danh Sách Chặn",
    WebStringKey.EnterDomainPrompt to "Nhập tên miền",
    WebStringKey.LatencyMs to "Độ Trễ",
    WebStringKey.StreakFire to "Chuỗi",
    WebStringKey.AccuracyPercent to "Độ Chính Xác",
    WebStringKey.ConfidencePercent to "Độ Tin Cậy",
    WebStringKey.English to "Tiếng Anh",
    WebStringKey.German to "Tiếng Đức",
    WebStringKey.Spanish to "Tiếng Tây Ban Nha",
    WebStringKey.French to "Tiếng Pháp",
    WebStringKey.ChineseSimplified to "Tiếng Trung (Giản Thể)",
    WebStringKey.Japanese to "Tiếng Nhật",
    WebStringKey.Hindi to "Tiếng Hindi",
    WebStringKey.Arabic to "Tiếng Ả Rập",
    WebStringKey.Indonesian to "Tiếng Indonesia",
    WebStringKey.Italian to "Tiếng Ý",
    WebStringKey.Korean to "Tiếng Hàn",
    WebStringKey.Portuguese to "Tiếng Bồ Đào Nha",
    WebStringKey.Russian to "Tiếng Nga",
    WebStringKey.Thai to "Tiếng Thái",
    WebStringKey.Turkish to "Tiếng Thổ Nhĩ Kỳ",
    WebStringKey.Vietnamese to "Tiếng Việt"
,
    WebStringKey.ComponentVoting to "Bỏ phiếu thành phần",
    WebStringKey.Heuristic to "Heuristic",
    WebStringKey.MLModel to "Mô hình ML",
    WebStringKey.Brand to "Thương hiệu",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Đa số phiếu quyết định kết quả: 3+ AN TOÀN = xanh, 2+ ĐỘC HẠI = đỏ"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Đang chờ quét...",
    WebStringKey.WaitingForAnalysis to "Đang chờ phân tích...",
    WebStringKey.ScanURLToSeeResults to "Quét URL để xem kết quả chi tiết.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Phím Tắt",
    WebStringKey.StartScanner to "Bắt Đầu Quét",
    WebStringKey.CloseMenuModal to "Đóng Menu / Hộp Thoại",
    WebStringKey.NavigateToDashboard to "Đi Tới Bảng Điều Khiển",
    WebStringKey.NavigateToHistory to "Lịch Sử Quét",
    WebStringKey.NavigateToTrust to "Trung Tâm Tin Cậy / Danh Sách Cho Phép",
    WebStringKey.NavigateToGame to "Trò Chơi Đánh Bại Bot",
    WebStringKey.ShowHelp to "Hiển Thị Trợ Giúp",
    WebStringKey.GotIt to "Đã Hiểu",
    WebStringKey.SecuritySettings to "Cài Đặt Bảo Mật",
    WebStringKey.SensitivityLevel to "Mức Độ Nhạy",
    WebStringKey.AutoBlockThreats to "Tự Động Chặn Mối Đe Dọa",
    WebStringKey.RealTimeScanning to "Quét Thời Gian Thực",
    WebStringKey.SoundAlerts to "Cảnh Báo Âm Thanh",
    WebStringKey.ThreatAlerts to "Cảnh Báo Mối Đe Dọa",
    WebStringKey.ShowConfidenceScore to "Hiển Thị Điểm Tin Cậy",
    WebStringKey.CompactView to "Chế Độ Xem Thu Gọn",
    WebStringKey.ResetDefaults to "Đặt Lại Mặc Định",
    WebStringKey.SaveAndContinue to "Lưu và Tiếp Tục",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "HOẠT ĐỘNG ĐÁNG NGờ",
    WebStringKey.VerdictWarning to "Cảnh báo",
    WebStringKey.VerdictSuspiciousDesc to "Mã QR được quét cho thấy các mẫu đáng ngờ có thể chỉ ra rủi ro bảo mật tiềm ẩn. Hãy tiến hành thận trọng.",
    WebStringKey.VerdictMinorConcerns to "LO NGẠI NHỎ",
    WebStringKey.VerdictCaution to "Thận trọng",
    WebStringKey.VerdictMinorConcernsDesc to "Đã phát hiện một số lo ngại bảo mật nhỏ. Liên kết có vẻ an toàn phần lớn nhưng khuyến cáo nên xem xét.",
    WebStringKey.VerdictVerifiedSafe to "ĐÃ XÁC MINH AN TOÀN",
    WebStringKey.VerdictSafeLabel to "An toàn",
    WebStringKey.VerdictVerifiedSafeDesc to "Không phát hiện mối đe dọa bảo mật. Mã QR dẫn đến đích an toàn đã được xác minh.",
    WebStringKey.VerdictNoActivity to "Không có hoạt động",
    WebStringKey.VerdictAwaitingScan to "Đang chờ quét",
    WebStringKey.VerdictNoActivityDesc to "Không có dữ liệu quét. Vui lòng quét mã QR hoặc nhập URL để phân tích.",
    WebStringKey.ScanQrToSeeActivity to "Quét mã QR để xem hoạt động của bạn tại đây",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Điểm dữ liệu",
    WebStringKey.ProcessingEnv to "Môi trường xử lý",
    WebStringKey.ExternalTransmission to "Truyền tải ra ngoài",
    WebStringKey.RawImageBuffer to "Bộ đệm hình ảnh thô",
    WebStringKey.LocalMemoryRam to "Bộ nhớ cục bộ (RAM)",
    WebStringKey.TransmissionNone to "Không có",
    WebStringKey.DecodedUrlPayload to "URL/Tải trọng đã giải mã",
    WebStringKey.LocalAnalysis to "Phân tích cục bộ",
    WebStringKey.ThreatVerdictLabel to "Phán quyết mối đe dọa",
    WebStringKey.LocalDatabase to "Cơ sở dữ liệu cục bộ",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Về Mehr Guard Security",
    WebStringKey.ActualDomain to "Tên Miền Thực",
    WebStringKey.AnalysisComplete to "Phân Tích Hoàn Tất",
    WebStringKey.AutoBlockThreatsDesc to "Tự động chặn các mối đe dọa",
    WebStringKey.AwaitingScanLabel to "Đang Chờ Quét",
    WebStringKey.BrandImpersonation to "Mạo Danh Thương Hiệu",
    WebStringKey.CautionAdvised to "Khuyến Cáo Thận Trọng",
    WebStringKey.CompactViewDesc to "Chế Độ Xem Thu Gọn",
    WebStringKey.DoNotVisit to "KHÔNG TRUY CẬP",
    WebStringKey.DoNotVisitDesc to "Phát hiện lừa đảo tin cậy cao. URL này có nhiều chỉ số độc hại.",
    WebStringKey.DomainUsesInternationalChars to "Tên miền này sử dụng các ký tự quốc tế có thể bắt chước các tên miền hợp pháp.",
    WebStringKey.GoToScanner to "Đi tới Máy Quét",
    WebStringKey.Hebrew to "Tiếng Do Thái",
    WebStringKey.HelpKeyboardShortcuts to "Phím Tắt",
    WebStringKey.HeuristicAnalysis to "Phân Tích Heuristic",
    WebStringKey.HeuristicAnalysisDesc to "URL được đánh dấu dựa trên nhiều yếu tố rủi ro được phát hiện bởi công cụ phân tích.",
    WebStringKey.HiddenDestination to "Đích Ẩn",
    WebStringKey.HighRisk to "Rủi Ro Cao",
    WebStringKey.HighRiskLabel to "RỦI RO CAO",
    WebStringKey.HomographIdnAttack to "Tấn Công Homograph / IDN",
    WebStringKey.InternationalizedDomainDetected to "Phát hiện tên miền quốc tế.",
    WebStringKey.JustNow to "Vừa xong",
    WebStringKey.KeyboardShortcutsDesc to "Phím tắt để truy cập nhanh",
    WebStringKey.LiveFeedActive to "NGUỒN CẤP TRỰC TIẾP ĐANG HOẠT ĐỘNG",
    WebStringKey.LowRisk to "Rủi Ro Thấp",
    WebStringKey.LowRiskLabel to "RỦI RO THẤP",
    WebStringKey.Malicious to "Độc Hại",
    WebStringKey.MediumRiskLabel to "RỦI RO TRUNG BÌNH",
    WebStringKey.NoData to "KHÔNG CÓ DỮ LIỆU",
    WebStringKey.NoScanDataResults to "Không có dữ liệu quét. Vui lòng quét URL để xem kết quả phân tích.",
    WebStringKey.NoUrlScanned to "Chưa quét URL nào",
    WebStringKey.Persian to "Tiếng Ba Tư",
    WebStringKey.PhishingIndicators to "Chỉ Số Lừa Đảo",
    WebStringKey.ProceedWithCaution to "TIẾN HÀNH CẨN THẬN",
    WebStringKey.ProceedWithCautionDesc to "Phát hiện một số chỉ số đáng ngờ. Xác minh nguồn trước khi nhập thông tin nhạy cảm.",
    WebStringKey.RealTimeScanningDesc to "Quét theo thời gian thực",
    WebStringKey.RedirectShortenerDetected to "Phát Hiện Chuyển Hướng/Rút Gọn",
    WebStringKey.SafeToVisit to "AN TOÀN ĐỂ TRUY CẬP",
    WebStringKey.SafeToVisitDesc to "Được xác minh bởi heuristic cục bộ v2.4. Không tìm thấy mẫu lừa đảo, script bị che giấu hoặc khớp danh sách đen.",
    WebStringKey.SafetyScore to "Điểm An Toàn",
    WebStringKey.ScanCompleteLabel to "Quét Hoàn Tất",
    WebStringKey.ScanToAnalyze to "Quét mã QR hoặc nhập URL để phân tích.",
    WebStringKey.ScannedURLLabel to "URL Đã Quét",
    WebStringKey.SecuritySignal to "Tín Hiệu Bảo Mật",
    WebStringKey.SensitivityLevelDesc to "Mức Độ Nhạy Cảm",
    WebStringKey.SensitivityPermissive to "Dễ Dãi",
    WebStringKey.SensitivityStrict to "Nghiêm Ngặt",
    WebStringKey.SettingsDetection to "Phát Hiện",
    WebStringKey.SettingsDisplay to "Hiển Thị",
    WebStringKey.SettingsLanguage to "Ngôn Ngữ",
    WebStringKey.SettingsLanguageDesc to "Chọn ngôn ngữ giao diện",
    WebStringKey.SettingsNotifications to "Thông Báo",
    WebStringKey.SettingsSavedAutomatically to "Cài đặt được lưu tự động và đồng bộ giữa các phiên.",
    WebStringKey.ShowConfidenceScoreDesc to "Hiển thị điểm tin cậy",
    WebStringKey.SoundAlertsDesc to "Cảnh báo âm thanh",
    WebStringKey.SuspiciousDomain to "Tên Miền Đáng Ngờ",
    WebStringKey.SuspiciousEncoding to "Mã Hóa Đáng Ngờ",
    WebStringKey.SuspiciousKeywords to "Từ Khóa Đáng Ngờ",
    WebStringKey.SuspiciousTld to "TLD Đáng Ngờ",
    WebStringKey.SuspiciousTldDesc to "Tên miền sử dụng {tld} TLD thường liên quan đến các trang web độc hại.",
    WebStringKey.SuspiciousUrlParams to "Tham Số URL Đáng Ngờ",
    WebStringKey.SuspiciousUrlParamsDesc to "URL chứa các tham số phức tạp hoặc có thể bị che giấu.",
    WebStringKey.ThreatAlertsDesc to "Cảnh báo mối đe dọa",
    WebStringKey.ThreatDetected to "Phát Hiện Mối Đe Dọa",
    WebStringKey.UnableToDetermine to "Không thể xác định kết luận. Vui lòng thử lại.",
    WebStringKey.Unknown to "Không Rõ",
    WebStringKey.UnknownURL to "URL Không Rõ",
    WebStringKey.UrlShortenerDesc to "URL sử dụng dịch vụ rút gọn ẩn đích cuối cùng.",
    WebStringKey.UrlShortenerDetected to "Phát Hiện Rút Gọn URL",
    WebStringKey.VersionOfflineReady to "Sẵn sàng ngoại tuyến",
    WebStringKey.VisualAppearance to "Hình Thức Hiển Thị",
    WebStringKey.WaitingForAnalysisLabel to "Đang chờ phân tích...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "Phát hiện lược đồ JavaScript URL - thực thi mã khi nhấp",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "Phát hiện lược đồ Data URI - có thể chứa mã độc nhúng",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Chèn Ký Hiệu @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL chứa ký hiệu @ cho thấy khả năng đánh cắp thông tin đăng nhập",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Tấn Công Homograph",
    WebStringKey.ReasonHomographDesc to "Tên miền quốc tế hóa (IDN) có thể mạo danh tên miền khác",
    WebStringKey.ReasonMixedScriptTitle to "Script Hỗn Hợp",
    WebStringKey.ReasonMixedScriptDesc to "Hostname chứa ký tự từ nhiều script (có thể giả mạo)",
    WebStringKey.ReasonLookalikeCharsTitle to "Ký Tự Giống Nhau",
    WebStringKey.ReasonLookalikeCharsDesc to "Tên miền chứa ký tự Unicode trông giống chữ ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "Ký Tự Không Chiều Rộng",
    WebStringKey.ReasonZeroWidthCharsDesc to "Phát hiện ký tự Unicode ẩn không chiều rộng (nỗ lực che giấu)",
    WebStringKey.ReasonIpHostTitle to "Máy Chủ IP",
    WebStringKey.ReasonIpHostDesc to "URL sử dụng địa chỉ IP thay vì tên miền",
    WebStringKey.ReasonCredentialParamTitle to "Tham Số Thông Tin Đăng Nhập",
    WebStringKey.ReasonCredentialParamDesc to "URL chứa các tham số liên quan đến thông tin đăng nhập (mật khẩu, token, v.v.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Mạo Danh Thương Hiệu",
    WebStringKey.ReasonBrandImpersonationDesc to "URL có vẻ đang mạo danh thương hiệu nổi tiếng",
    WebStringKey.ReasonBrandInSubdomainTitle to "Thương Hiệu Trong Subdomain",
    WebStringKey.ReasonBrandInSubdomainDesc to "Tên thương hiệu xuất hiện trong subdomain nhưng không phải tên miền chính",
    WebStringKey.ReasonRiskyExtensionTitle to "Phần Mở Rộng Rủi Ro",
    WebStringKey.ReasonRiskyExtensionDesc to "Đường dẫn chứa phần mở rộng tệp tiềm ẩn nguy hiểm",
    WebStringKey.ReasonDoubleExtensionTitle to "Phần Mở Rộng Kép",
    WebStringKey.ReasonDoubleExtensionDesc to "Phát hiện phần mở rộng tệp kép (chiến thuật phần mềm độc hại phổ biến)",
    WebStringKey.ReasonEncodedPayloadTitle to "Payload Được Mã Hóa",
    WebStringKey.ReasonEncodedPayloadDesc to "Phát hiện dữ liệu được mã hóa lớn trong tham số URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP Không Phải HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL sử dụng giao thức HTTP không an toàn thay vì HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD Đáng Ngờ",
    WebStringKey.ReasonSuspiciousTldDesc to "Tên miền cấp cao nhất thường được sử dụng cho lừa đảo",
    WebStringKey.ReasonHighEntropyHostTitle to "Máy Chủ Entropy Cao",
    WebStringKey.ReasonHighEntropyHostDesc to "Tên miền có vẻ được tạo ngẫu nhiên",
    WebStringKey.ReasonRedirectParamTitle to "Tham Số Chuyển Hướng",
    WebStringKey.ReasonRedirectParamDesc to "URL chứa tham số chuyển hướng có thể dẫn đến trang web khác",
    WebStringKey.ReasonDeepSubdomainTitle to "Subdomain Sâu",
    WebStringKey.ReasonDeepSubdomainDesc to "Độ sâu subdomain quá mức (có thể ẩn tên miền thực)",
    WebStringKey.ReasonMultiTldTitle to "Nhiều TLD",
    WebStringKey.ReasonMultiTldDesc to "Nhiều phân đoạn giống TLD trong tên miền",
    WebStringKey.ReasonNumericSubdomainTitle to "Subdomain Số",
    WebStringKey.ReasonNumericSubdomainDesc to "Phát hiện subdomain chỉ có số",
    WebStringKey.ReasonNonStandardPortTitle to "Cổng Không Chuẩn",
    WebStringKey.ReasonNonStandardPortDesc to "URL sử dụng số cổng không chuẩn",
    WebStringKey.ReasonSuspiciousPortTitle to "Cổng Đáng Ngờ",
    WebStringKey.ReasonSuspiciousPortDesc to "URL sử dụng cổng thường liên quan đến tấn công",
    WebStringKey.ReasonFragmentHidingTitle to "Ẩn Fragment",
    WebStringKey.ReasonFragmentHidingDesc to "Fragment URL có vẻ đang ẩn nội dung bổ sung",
    WebStringKey.ReasonExcessiveEncodingTitle to "Mã Hóa Quá Mức",
    WebStringKey.ReasonExcessiveEncodingDesc to "Phát hiện mã hóa URL quá mức (nỗ lực che giấu)",
    WebStringKey.ReasonDomainAgePatternTitle to "Mẫu Tuổi Tên Miền",
    WebStringKey.ReasonDomainAgePatternDesc to "Tên miền khớp với các mẫu tên miền được tạo tự động",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Rút Gọn URL",
    WebStringKey.ReasonUrlShortenerDesc to "URL sử dụng dịch vụ rút gọn (ẩn đích thực)",
    WebStringKey.ReasonSuspiciousPathTitle to "Đường Dẫn Đáng Ngờ",
    WebStringKey.ReasonSuspiciousPathDesc to "Đường dẫn chứa từ khóa đáng ngờ (login, verify, v.v.)",
    WebStringKey.ReasonLongUrlTitle to "URL Dài",
    WebStringKey.ReasonLongUrlDesc to "URL dài bất thường",
    WebStringKey.ReasonCredentialKeywordsTitle to "Từ Khóa Thông Tin Đăng Nhập",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL chứa từ khóa thu thập thông tin đăng nhập",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL Không Thể Phân Tích",
    WebStringKey.ReasonUnparseableDesc to "Không thể phân tích hoàn toàn URL",
    WebStringKey.ReasonAnalysisCompleteTitle to "Phân Tích Hoàn Tất",
    WebStringKey.ReasonAnalysisCompleteDesc to "Phân tích hoàn tất thành công",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "Điểm Lừa Đảo ML",
    WebStringKey.MlCharacterAnalysis to "Phân tích ký tự",
    WebStringKey.MlFeatureAnalysis to "Phân tích tính năng",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "Tên Miền IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "Tên miền này sử dụng ký tự quốc tế. Hiển thị an toàn:",
    WebStringKey.MixedScriptAttackTitle to "Tấn Công Script Hỗn Hợp",
    WebStringKey.MixedScriptAttackDesc to "Tên miền chứa ký tự từ nhiều hệ chữ viết (ví dụ: Cyrillic + Latin). Phổ biến trong các cuộc tấn công homograph.",
    WebStringKey.ConfusableCharsTitle to "Ký Tự Dễ Nhầm Lẫn",
    WebStringKey.ConfusableCharsDesc to "Tên miền chứa các ký tự trông giống chữ cái thông thường (ví dụ: 'а' vs 'a')."
)

internal val VietnameseCommonStrings = mapOf(
    "Engine Active" to "Động Cơ Hoạt Động",
    "Enterprise Protection Active" to "Bảo Vệ Doanh Nghiệp Hoạt Động",
    "Secure. Offline.\nExplainable Defence." to "An Toàn. Ngoại Tuyến.\nPhòng Thủ Có Thể Giải Thích.",
    "Start New Scan" to "Bắt Đầu Quét Mới",
    "Import Image" to "Nhập Hình Ảnh",
    "System Health" to "Tình Trạng Hệ Thống",
    "Threat Database" to "Cơ Sở Dữ Liệu Mối Đe Dọa",
    "Current" to "Hiện Tại",
    "Heuristic Engine" to "Động Cơ Heuristic",
    "Active" to "Hoạt Động",
    "Threats" to "Mối Đe Dọa",
    "Safe Scans" to "Quét An Toàn",
    "Offline-First Architecture" to "Kiến Trúc Ưu Tiên Ngoại Tuyến",
    "Explainable Security" to "Bảo Mật Có Thể Giải Thích",
    "High-Performance Engine" to "Động Cơ Hiệu Suất Cao",
    "Recent Scans" to "Quét Gần Đây",
    "View Full History" to "Xem Lịch Sử Đầy Đủ",
    "Status" to "Trạng Thái",
    "Source" to "Nguồn",
    "Details" to "Chi Tiết",
    "Time" to "Thời Gian",
    "SAFE" to "AN TOÀN",
    "SUSPICIOUS" to "ĐÁNG NGHI",
    "PHISHING" to "LỪA ĐẢO",
    "UNKNOWN" to "KHÔNG XÁC ĐỊNH",
    "Trusted Domain" to "Tên Miền Tin Cậy",
    "Version" to "Phiên Bản",
    "Last Update" to "Cập Nhật Cuối",
    "Signatures" to "Chữ Ký",
    "Check for Updates" to "Kiểm Tra Cập Nhật",
    "WAITING FOR INPUT" to "ĐANG CHỜ NHẬP",
    "SCANNING" to "ĐANG QUÉT",
    "ANALYZING" to "ĐANG PHÂN TÍCH",
    "ERROR" to "LỖI",
    "SCAN COMPLETE" to "QUÉT HOÀN TẤT",
    "Active Scanner" to "Máy Quét Hoạt Động",
    "Mode:" to "Chế Độ:",
    "Offline First" to "Ngoại Tuyến Trước",
    "Enable Camera" to "Bật Camera",
    "Torch" to "Đèn Pin",
    "Upload Image" to "Tải Lên Hình Ảnh",
    "Paste URL" to "Dán URL",
    "SYSTEM STATUS" to "TRẠNG THÁI HỆ THỐNG",
    "Detection Engine" to "Động Cơ Phát Hiện",
    "Phishing Guard" to "Bảo Vệ Lừa Đảo",
    "READY" to "SẴN SÀNG",
    "Database" to "Cơ Sở Dữ Liệu",
    "LATEST" to "MỚI NHẤT",
    "Latency" to "Độ Trễ",
    "RECENT SCANS" to "QUÉT GẦN ĐÂY",
    "View All" to "Xem Tất Cả",
    "No scans yet" to "Chưa có quét",
    "Export Log" to "Xuất Nhật Ký",
    "Scan History" to "Lịch Sử Quét",
    "Safe" to "An Toàn",
    "Suspicious" to "Đáng Nghi",
    "Dangerous" to "Nguy Hiểm",
    "Risk" to "Rủi Ro",
    "Verdict" to "Phán Quyết",
    "Actions" to "Hành Động",
    "Scan" to "Quét",
    "Results" to "Kết Quả",
    "ENGINE ACTIVE" to "ĐỘNG CƠ HOẠT ĐỘNG",
    "Safe to Visit" to "An Toàn Để Truy Cập",
    "Confidence" to "Độ Tin Cậy",
    "Scan Time" to "Thời Gian Quét",
    "Engine" to "Động Cơ",
    "Visit URL" to "Truy Cập URL",
    "Copy Safe Link" to "Sao Chép Liên Kết An Toàn",
    "Export Report" to "Xuất Báo Cáo",
    "Dashboard" to "Bảng Điều Khiển",
    "Mehr Guard" to "Mehr Guard",
    "Settings" to "Cài Đặt",
    "Language" to "Ngôn Ngữ",
    "Training Centre" to "Trung Tâm Đào Tạo",
    "Analyze" to "Phân Tích"
)
